import {getLiveUrl, checkUser} from "../../api/forum";
import Cookies from "js-cookie";
const live = {
  state: {

  },
  mutations: {
  },
  actions: {
    //进入直播间获取相关参数
    getLiveInfo({commit}, liveInfo) {
      return new Promise((resolve, reject) => {
        getLiveUrl(liveInfo).then(res => {
          // if (res.type == '1') {
          //   commit("SET_SIGN",)
          // }
          resolve(res);
        }).catch(err => reject(err))
      })
    }
  }
};

export default live;
